const requestError = {
  en: {
    title: "Ops!",
    default:
      "An error occurred during the request. Please try again in a few moments"
  },
  pt: {
    title: "Ops!",
    default:
      "Ocorreu um erro durante o pedido. Por favor, tente novamente dentro de alguns instantes"
  },
  es: {
    title: "Ops!",
    default:
      "Se ha producido un error durante la solicitud. Por favor, inténtelo de nuevo en unos momentos"
  }
}

export default requestError
